(function WatchLists($, Adzuki) {
	"use strict";

	var $modal = $(".modal");

	Adzuki.onload('WatchLists/index', function onload() {
		var watch_list_id = 0;
		let hasSelected   = {};

		$('.table li.table-row').on('click', function showDelete() {
			let watchListId = $(this).data('watch-list-id');

			if ($(this).hasClass('selected')) {
				hasSelected[watchListId] = watchListId;
			} else {
				delete hasSelected[watchListId];
			}
			_toggleDelete(hasSelected);
		});

		$('.select-all-btn').click(function toggleDeleteLink() {
			$(this).toggleClass('selected');

			if ($(this).hasClass('selected')) {
				hasSelected['all'] = 'all';
			} else {
				hasSelected = {};
			}
			_toggleDelete(hasSelected);
		});

		$('.watch-list').each(function watchListCheckCount() {
			watch_list_id = $(this).data("watch-list-id");

			Adzuki.Ajax.get('/WatchLists/getCount/' + watch_list_id)
			.then(function success(data) {
				$('#watch-list-itin-count-' + data.id).html(data.count);
			});
		});

		$('.watch-list-itin-count').click(function doFindACruise(e) {
			var watch_list_id = $(this).data("id");

			e.preventDefault(e);

			document.location = Adzuki.base_uri + '/WatchLists/forward/' + watch_list_id;
		});

		$('.watch-list-details').click(function showWatchListDetail(e) {
			var watch_list_id = $(this).data("id");

			e.preventDefault();

			$modal.find('.modal-title').text("Watch List Detail");
			$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading...');
			$modal.modal('show');

			Adzuki.Ajax.get('/WatchLists/details/' + watch_list_id)
			.then(function success(data) {
				$modal.find('.modal-body').html(data);
			});
		});

		$('.watchlist-bulk-delete').on('click', function bulkDelete(e) {
			let $table        = $('.table');
			let checkedValues = {};
			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to delete the selected watch lists? Clicking "Yes" will permanently delete them, and they will not be recoverable.',
				confirm: function confirm() {
					// Find all checked inputs inside the table and get their values
					$table.find('input[type="checkbox"]:checked').each(function add() {
						let k = $(this).attr('id') || `key_${$(this).val()}`;
						checkedValues[k] = $(this).val();
					});

					Adzuki.Ajax.post('/WatchLists/bulkDelete', checkedValues)
						.then(function deletedIds(data) {
							Adzuki.StatusMessage('success', 'The watch lists have been deleted', 'Success', {
								onClose: function refreshScreen() {
									window.location.reload();
								},
							});
						});
				}
			});

		});

		function _toggleDelete(hasSelected)
		{
			if (Object.entries(hasSelected).length > 0) {
				$('.watchlist-bulk-delete').removeClass('disabled');
			} else {
				$('.watchlist-bulk-delete').addClass('disabled');
			}
		}
	});

}(jQuery, window.Adzuki || {}));
